import core from './commuCore'
const output = {}

// 删除报告中的元素的时候判断该元素是否只关联这一个报告，如果是则将该元素标记删除
function delAttachment (attachment) {
  return core.ajax(attachment, '/element', 'delete')
}
output.delAttachment = delAttachment

/* —————————————————————— 专家说相关api —————————————————————— */
// 新增专家说
function addNewQuote (quote) {
  return core.ajax(quote, '/quote', 'post')
}
output.addNewQuote = addNewQuote

// 获取专家说分页
function getQuotePage (query) {
  return core.ajax(query, '/quote/page', 'get')
}
output.getQuotePage = getQuotePage

// 删除专家说
function deleteQuote (condition) {
  return core.ajax(condition, '/quote', 'delete')
}
output.deleteQuote = deleteQuote

// 更新专家说
function updateQuote (condition) {
  return core.ajax(condition, '/quote', 'put')
}
output.updateQuote = updateQuote

function autoMatchQuote (condition) {
  return core.ajax(condition, '/quote/match', 'get')
}
output.autoMatchQuote = autoMatchQuote

// 根据id获取专家详情
function getQuotebyId (id) {
  return core.ajax(id, '/quote/getById', 'get')
}
output.getQuotebyId = getQuotebyId

function allContent (data) {
  return core.ajax(data, '/quote/allContent', 'get')
}
output.allContent = allContent

/* —————————————————————— 政策相关api —————————————————————— */
function addTable (data) {
  return core.ajax(data, '/table', 'post')
}
output.addTable = addTable

function getTable (data) {
  return core.ajax(data, '/table', 'get')
}
output.getTable = getTable

function updateTable (data) {
  return core.ajax(data, '/table', 'put')
}
output.updateTable = updateTable

function deleteTable (data) {
  return core.ajax({ data }, '/table', 'delete')
}
output.deleteTable = deleteTable

function getTablebyId (id) {
  return core.ajax(id, '/table/getTablebyId', 'get')
}
output.getTablebyId = getTablebyId

/* —————————————————————— Size相关api —————————————————————— */
// size保存
function saveSize (data) {
  return core.ajax(data, '/sizePro/', 'post')
}
output.saveSize = saveSize

// sizepro修改
function updateSize (data) {
  return core.ajax(data, '/sizePro/', 'put')
}
output.updateSize = updateSize

// sizepro信息获取
function getSizePro (data) {
  return core.ajax(data, '/sizePro/', 'get')
}
output.getSizePro = getSizePro

// sizePro列表
function getSizePage (data) {
  return core.ajax(data, '/sizePro/getSizePage', 'get')
}
output.getSizePage = getSizePage

// 删除sizePro
function deleteSize (data) {
  return core.ajax({ data }, '/sizePro/deleteSize', 'DELETE')
}
output.deleteSize = deleteSize

/* —————————————————————— Ill相关api —————————————————————— */
// size保存
function insertIll (data) {
  return core.ajax(data, '/illustration/put', 'put')
}
output.insertIll = insertIll

function updateIll (data) {
  return core.ajax(data, '/illustration', 'put')
}
output.updateIll = updateIll

function ocr (data) {
  return core.ajax(data, '/illustration/ocr', 'post')
}
output.ocr = ocr

function getOcrCount (data) {
  return core.ajax(data, '/illustration/getOcrCount', 'get')
}
output.getOcrCount = getOcrCount

function batchOcr (data) {
  return core.ajax(data, '/illustration/batchOcr', 'get')
}
output.batchOcr = batchOcr

export default output
